import { useEffect } from "react";
import { useLocation } from "wouter";

/**
 * ScrollToTop — scrolls the window to the top on every route change.
 * Mount this once inside the Router so it fires on every navigation.
 */
export default function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);

  return null;
}
